import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import validationform from '../../../validation/validationform';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Validation from '../../../validation/confirm-password-validation';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { SettingsService } from './service/settings.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { StripeCardElementOptions, StripeElementsOptions } from '@stripe/stripe-js';
import { StripeCardComponent, StripeService } from 'ngx-stripe';
import { LoginService } from '../../../components/login/service/login.service';
import * as CryptoJS from 'crypto-js';
import intlTelInput from 'intl-tel-input';


@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent {
    tabTriangle = '';
  planType = ['Business Plus', 'Business', 'Trial'];
  activePlanData: any = [];
  planId!: number;
  planName!: string;
  showPlans = 'subcriptionDetails';
  purchaseData: any = [];
  usageDataTemp: any = [];
  usageData: any = [];
  profileData: any = [];
  authenticationData: any = [];
  authenticationEvent: any;
  companyLogoData: any = [];
  authentication!: boolean;
  chooseEmail: boolean = true;
  choosePhone: boolean = false;
  choosenValue!: string;
  submitted: boolean = false;
  type: string = 'password';
  isText = false;
  eyeIcon = 'fa-eye-slash';
  passwordIcon = 'fa fa-lock';
  passwordForm: FormGroup = new FormGroup({
    currentPassword: new FormControl(''),
    newPassword: new FormControl(''),
    confirmPassword: new FormControl(''),
  });
  private readonly notifier: NotifierService;
  profileForm: FormGroup=new FormGroup({});
  fileData: any = [];
  companyLogofileData: any = [];
  getFileEvent: any;
  imageSrc: any;
  companyLogoImageSrc: any;
  showPrfilePic: boolean = false;
  showCompanyLogo: boolean = false;
  @ViewChild('fileUpload') fileUploadEle: any;
  @ViewChild('fileUpload2') fileUploadEle2: any;
  @ViewChild('usageTab') usageTab!: ElementRef;
  myBlob = new Blob();
  blobFile!: File;
  blobUrl: any;
  audioSafeUrl!: SafeUrl;
  companyLogoForm: FormGroup=new FormGroup({});
  getPictureValue: string = '';
  spinner: boolean = false;
  subscriptionForm!: FormGroup;
  userCountEntry: number = 1;
  userCount!: number;
  accessPhotoSelect: boolean = false;
  accessCompanyPhotoSelect: boolean = false;
  currentPlanData!: string;
  selectedCountry!: string;
  zip!: string;
  buyPlan!: string;
  cardStripedToken!: string;
  showSuccessSubscription: boolean = false;
  subscriptionPlanId!: number;
  spinner2: boolean = false;
  cardNumber!: string;
  userDetails: any;
  userDetails_2:any;
  userSubscription:any;
  maximum_file_per_agent!:number;
  country_list = [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antigua &amp; Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia',
    'Bosnia &amp; Herzegovina',
    'Botswana',
    'Brazil',
    'British Virgin Islands',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Cape Verde',
    'Cayman Islands',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Congo',
    'Cook Islands',
    'Costa Rica',
    'Cote D Ivoire',
    'Croatia',
    'Cruise Ship',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands',
    'Faroe Islands',
    'Fiji',
    'Finland',
    'France',
    'French Polynesia',
    'French West Indies',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea Bissau',
    'Guyana',
    'Haiti',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kuwait',
    'Kyrgyz Republic',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macau',
    'Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Namibia',
    'Nepal',
    'Netherlands',
    'Netherlands Antilles',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Norway',
    'Oman',
    'Pakistan',
    'Palestine',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Reunion',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Pierre &amp; Miquelon',
    'Samoa',
    'San Marino',
    'Satellite',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'South Africa',
    'South Korea',
    'Spain',
    'Sri Lanka',
    'St Kitts &amp; Nevis',
    'St Lucia',
    'St Vincent',
    'St. Lucia',
    'Sudan',
    'Suriname',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    "Timor L'Este",
    'Togo',
    'Tonga',
    'Trinidad &amp; Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks &amp; Caicos',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'Uruguay',
    'Uzbekistan',
    'Venezuela',
    'Vietnam',
    'Virgin Islands (US)',
    'Yemen',
    'Zambia',
    'Zimbabwe',
  ];
  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#31325F',
        fontWeight: '300',
        // fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '20px',
        '::placeholder': {
          color: '#CFD7E0',
        },
      },
    },
  };
  elementsOptions: StripeElementsOptions = {
    locale: 'en',
  };
  stripeCardValid: boolean = false;
  initContry:any;
  myOptions:any = {
    placement: 'top',
    showDelay: 200,
    hideDelay: 0,
    maxWidth: 200,
    zIndex: 100000,
    trigger: 'hover',
    shadow: true,
  };
  @Output() private emitImageSrc = new EventEmitter();
  @Output() private emitImageSrcData = new EventEmitter();
  @Output() private emitUpdatedDetails = new EventEmitter();
  @ViewChild(StripeCardComponent) card!: StripeCardComponent;
  @ViewChild('intlInput') intlInput!: ElementRef;
  constructor(
    private subscriptionService: SettingsService,
    private fb: FormBuilder,
    private notifierService: NotifierService,
    private sanitizer: DomSanitizer,
    private activatedRoute: ActivatedRoute,
   private stripeService: StripeService,
    private service:LoginService,
    private router:Router
  ) {
    this.notifier = notifierService;
  }

  ngOnChanges() {}

  ngOnInit(): void {
      let user:any = localStorage.getItem("user");
        var data = CryptoJS.AES.decrypt(user,this.service.enCryptKey).toString(CryptoJS.enc.Utf8);
       this.userDetails = JSON.parse(data);
       this.userDetails_2 = JSON.parse(data);
       this.userSubscription = this.userDetails?.plan_id;
    this.passwordForm = this.fb.group(
      {
        currentPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(40),
            Validators.pattern(
              '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{8,}'
            ),
          ],
        ],
        newPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(40),
            Validators.pattern(
              '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{8,}'
            ),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      {
        validators: [Validation.match('newPassword', 'confirmPassword')],
      }
    );

    this.profileForm = this.fb.group({
      name: ['', [Validators.required,,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      email: ['',[Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      phone: ['', [Validators.required, Validators.pattern("^[+][0-9]{12}$")]],
      user_image: [''],
    });
    this.companyLogoForm = this.fb.group({
      title: ['', [Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      caption: ['',[Validators.required,Validators.pattern(/^[A-Za-z\-]+(?:\s[A-Za-z]+)*$/)]],
      logo: ['', Validators.required],
    });

    this.subscriptionForm = this.fb.group({
      card_name: ['',[Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      card_number: [''],
      userscount: [''],
      company_name: [null,[Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      address1: [null,[Validators.required,Validators.pattern(/^[A-Za-z0-9-]+(?:\s[A-Za-z]+)*$/)]],
      address2: [null,[Validators.required,Validators.pattern(/^[A-Za-z0-9-]+(?:\s[A-Za-z]+)*$/)]],
      city: [null,[Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      state: [null,[Validators.required,Validators.pattern(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/)]],
      country: [null,Validators.required],
    });
    // this.userDetails = this.appComponent.userDetailsAppComp;
    // this.userDetails_2 = this.appComponent.userDetailsAppComp;
    // this.userSubscription = this.userDetails[0]?.plan_id;
    if (this.userDetails?.role === 102) {
      if(this.userSubscription !== 1 && this.userSubscription){
        this.getActivePlanDetails();
      }
      this.showTriangle('subscription');
    }
    if (this.userDetails?.role === 100) {
      this.getUsageData();
      this.showTriangle('usage');
    }
    if (this.userDetails?.role === 101) {
      this.showTriangle('passwordReset');
    }

  }

  get f(): { [key: string]: AbstractControl } {
    return this.passwordForm.controls;
  }

  get fCompany(): { [key: string]: AbstractControl } {
    return this.companyLogoForm.controls;
  }

  get profile():{[key:string]:AbstractControl}{
     return this.profileForm.controls;
  }

  get fsubscription(): { [key: string]: AbstractControl } {
    return this.subscriptionForm.controls;
  }

  hideShowPassword() {
    this.isText = !this.isText;
    this.isText ? (this.eyeIcon = 'fa-eye') : (this.eyeIcon = 'fa-eye-slash');
    this.isText ? (this.type = 'text') : (this.type = 'password');
  }

  showTriangle(value: string) {
    this.tabTriangle = value;
    this.submitted = false;
    this.fileData = [];
    this.companyLogoData = [];
    this.companyLogoForm.get('logo')?.setValue(null);
    if (this.tabTriangle === 'subscription') {
      this.showPlans = 'subcriptionDetails';
    } else {
      this.showPlans = '';
    }
  }

  getActivePlanDetails() {
    this.spinner = true;
    this.subscriptionService.getActivePlan().subscribe({
      next: (response:any) => {
        this.activePlanData = response;
        this.userCountEntry = this.activePlanData.active_users_count
          ? this.activePlanData.active_users_count
          : 1;
        this.userCount = this.activePlanData.active_users_count
          ? this.activePlanData.active_users_count
          : 1;
        this.planId = this.activePlanData.plan_id;
        if (this.planId === 1) {
          this.planName = this.planType[2];
        } else if (this.planId === 2) {
          this.planName = this.planType[1];
        } else if (this.planId === 3) {
          this.planName = this.planType[0];
        }
        this.spinner = false;
      },
      error: (error:HttpErrorResponse) => {
        console.log('active plan api error');
        this.spinner = false;
      },
    });
  }

  upgradePlans(value: string) {
    this.showPlans = value;
  }

  getPurchaseData() {
    this.spinner = true;
    this.subscriptionService.getPurchase().subscribe({
      next: (response:any) => {
        this.purchaseData = response;
        this.spinner = false;
      },
      error: (error:HttpErrorResponse) => {
        console.log('purchase payment error');
        this.spinner = false;
      },
    });
  }

  getUsageData() {
    this.spinner = true;
    this.subscriptionService.getUsage().subscribe({
      next: (response:any) => {
        this.usageDataTemp = response;
        this.usageData = this.usageDataTemp.result;
        this.spinner = false;
      },
      error: (error:HttpErrorResponse) => {
        this.spinner = false;
        console.log('purchase payment error');
      },
    });
  }

  chooseCountry(value: any) {
    this.subscriptionForm.controls['country'].setValue(value);
  }

  getProfileData() {
    this.spinner = true;
    //this.phoneNumberInitialLoad();
    this.subscriptionService.getProfile().subscribe({
      next: (response:any) => {
        this.profileData = response;
      
       
        this.profileForm.controls['name'].setValue(this.profileData.name);
        this.profileForm.controls['email'].setValue(this.profileData.email);
        this.profileForm.controls['phone'].setValue(this.profileData.phone);
        this.profileForm?.get('email')?.disable();
  
        const imageBase64 = this.profileData.user_image.replace(/b'|'/g, '');
        this.imageSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
          'data:image/jpg;base64,' + imageBase64
        );
        if (this.profileData.user_image) {
          this.showPrfilePic = true;
        } else {
          this.showPrfilePic = false;
        }
        if (!this.profileData.user_image) {
          this.accessPhotoSelect = true;
        } else {
          this.accessPhotoSelect = false;
        }
        this.spinner = false;
      },
      error: (error:HttpErrorResponse) => {
        console.log('profile error');
        this.spinner = false;
      },
    });
  }

  getAuthenticationData() {
    this.spinner = true;
    this.subscriptionService.getAuthentication().subscribe({
      next: (response:any) => {
        this.chooseEmail = false;
        this.choosePhone = false;
        this.authenticationData = response;
        this.authentication = this.authenticationData.is_enabled;
        this.spinner = false;
        if (this.authenticationData.sendotpto === 'email') {
          this.chooseEmail = true;
          this.choosePhone = false;
        }
        if (this.authenticationData.sendotpto === 'mobile') {
          this.choosePhone = true;
          this.chooseEmail = false;
        }
        if (this.authenticationData.sendotpto === 'both') {
          this.choosePhone = true;
          this.chooseEmail = true;
        }
      },
      error: (error:HttpErrorResponse) => {
        console.log('authentication api error');
        this.spinner = false;
      },
    });
  }

  changeAuthentication(value: any) {
    this.authenticationEvent = value;
    this.authentication = !this.authentication;
    if (this.authentication === true) {
      this.chooseEmail = true;
    } else {
      this.chooseEmail = false;
    }
  }

  chooseEmailFun(value: string) {
    if (this.authentication === true) {
      this.authenticationEvent = value;
      this.chooseEmail = !this.chooseEmail;
    }
    // this.chooseEmail = false;
  }

  choosePhoneFun(value: string) {
    if (this.authentication === true) {
      this.authenticationEvent = value;
      this.choosePhone = !this.choosePhone;
    }
    // this.chooseEmail = false;
  }

  updateAuthentication() {
      if (this.authentication === true) {
       if(this.chooseEmail==false && this.choosePhone==false){
           this.notifier.notify('error',"You must select any one send OTP option");
           return;
       }
     }
    if (this.chooseEmail) {
      this.choosenValue = 'email';
    }
    if (this.choosePhone) {
      this.choosenValue = 'mobile';
    }
    if (this.choosePhone && this.chooseEmail) {
      this.choosenValue = 'both';
    }
    if (!this.choosePhone && !this.chooseEmail) {
      this.choosenValue = '';
    }

    if(this.authentication==false){
      this.choosenValue='';
    }
    const payload = {
      enable: this.choosenValue ? true : false,
      sendotpto: this.choosenValue,
    };
    this.spinner = true;
    this.subscriptionService.updateTwoWayAuthentication(payload).subscribe({
      next: (response:any) => {
         this.notifier.notify('default',response['result']);
        if (!payload.enable) {
          this.authentication = false;
        }
        this.spinner = false;
      },
      error: (error:HttpErrorResponse) => {
        console.log('update two way authentication api error');
        this.spinner = false;
      },
    });
  }

  makeRandom(lengthOfCode: number, possible: string) {
    let text = '';
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  updatePassword() {
    this.submitted = true;
    const values = this.passwordForm.value;
    const email = values.email;
    const newPassword = values.newPassword;
    const currentPassword = values.currentPassword;
    const possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,./;'[]=-)(*&^%$#@!~`";
    const dynamic_str = this.makeRandom(16, possible);
    const salt = this.makeRandom(16, possible);
    const iterations = 128;
    const bytes = CryptoJS.PBKDF2(dynamic_str, salt, {
      keySize: 48,
      iterations: iterations,
    });
    const iv = CryptoJS.enc.Hex.parse(bytes.toString().slice(0, 32));
    const key = CryptoJS.enc.Hex.parse(bytes.toString().slice(32, 96));

    const ciphertext = CryptoJS.AES.encrypt(currentPassword, key, { iv: iv });
    const ciphertext2 = CryptoJS.AES.encrypt(newPassword, key, { iv: iv });
    const formEncript = {
      encrypted_data1: ciphertext.toString(),
      encrypted_data2: ciphertext2.toString(),
      salt: salt,
      pass_phrase: dynamic_str,
    };

    if (this.passwordForm.valid) {
      this.spinner = true;
      this.subscriptionService.updatePassword(formEncript).subscribe({
        next: (response:any) => {
          this.submitted = false;
          this.notifier.notify('default', 'Password Updated Successfully !');
          this.spinner = false;
          let userid:any = this.service.userDetails['userid'];
          this.service.logout(userid).subscribe(
      {
        next:(res:any)=>{
         this.notifier.notify('default','You are successfully logged out');
        localStorage.clear();
        this.router.navigate(['login']);
    },
      error:(error:HttpErrorResponse)=>{

      }
    });
        },
        error: (error:HttpErrorResponse) => {
          this.notifier.notify('default', 'Incorrect Password !');
          this.spinner = false;
        },
      });
    }
  }

  onFileChange(event: any,Filetypes:any, value: string) {
    this.getFileEvent = event;

    if(!this.validateFileSelect(event,Filetypes)){
       if(value==='companyLog'){
      this.fileUploadEle2.nativeElement.value=null;
    }
    if(value==='profile'){
      this.fileUploadEle.nativeElement.value=null;
    }
      this.notifier.notify(
        'default',
        "Sorry we can't process the File Type. Only accepted files "+Filetypes.join(", ")
      );
      return;
    }
   
    this.getPictureValue = value;
    this.fileData = [];
    this.companyLogofileData = [];
    if (value === 'companyLogo') {
      if (this.getFileEvent.target.files.length > 0) {
        const file = this.getFileEvent.target.files[0]
          ? this.getFileEvent.target.files[0]
          : null;
        this.companyLogofileData?.push(file);
        const reader = new FileReader();
        reader.onload = (e) => (this.companyLogoImageSrc = reader.result);
        reader.readAsDataURL(file);
        this.showCompanyLogo = true;
        this.notifier.notify("default","Company logo updated.");
      }
    }
    if (value === 'profile') {
      if (this.getFileEvent.target.files.length > 0) {
        const file = this.getFileEvent.target.files[0]
          ? this.getFileEvent.target.files[0]
          : null;
        this.fileData?.push(file);
        const reader = new FileReader();
        reader.onload = (e) => (this.imageSrc = reader.result);
        reader.readAsDataURL(file);
        this.showPrfilePic = true;
        this.notifier.notify("default","Profile updated successfully.");
      }
    }
  }

  removeProfilepic() {
    if (this.getPictureValue === 'companyLogo') {
      this.companyLogoImageSrc = '';
      this.fileUploadEle2.nativeElement.value = null;
      this.showCompanyLogo = false;
      this.companyLogofileData = [];
      this.accessCompanyPhotoSelect = true;
      this.companyLogoData.logo = '';
      this.notifier.notify('default',"Company logo deleted successfully.");
    }
    if (this.getPictureValue === 'profile') {
      this.imageSrc = '';
      this.fileUploadEle.nativeElement.value = null;
      this.showPrfilePic = false;
      this.fileData = [];
      this.accessPhotoSelect = true;
      this.profileData.user_image = '';
      this.notifier.notify('default',"Profile picture deleted successfully.");
    }
  }
  deletePic(value: string) {
    this.getPictureValue = value;
    this.fileUploadEle.nativeElement.value = null;
  }

  updateProfileData() {
     // let countryCode2 = this.initContry.getSelectedCountryData().dialCode;
    this.submitted=true;
    const formInput = {
      name: this.profileForm.controls['name'].value,
     // email: this.profileForm.controls['email'].value,
      phoneno:this.profileForm.controls['phone'].value,
    };
    const convertJson = JSON.stringify(formInput);
    const formData = new FormData();
    if (this.profileData.user_image && !this.fileData[0]) {
      const file = this.DataURIToBlob(
        this.imageSrc.changingThisBreaksApplicationSecurity
      );
      formData.append('file', file, 'image.jpg');
    } else if (
      this.profileData.user_image ||
      (!this.profileData.user_image && this.fileData[0])
    ) {
      formData.append('file', this.fileData[0] ? this.fileData[0] : null);
    } else if (!this.fileData[0]) {
      formData.append('file', this.fileData[0] ? this.fileData[0] : null);
    }
    formData.append('payload', convertJson);

    if (this.profileForm.valid) {
      this.spinner = true;
      this.submitted = false;
      this.subscriptionService.updateProfile(formData).subscribe({
        next: (response:any) => {
          this.notifier.notify('default', 'Profile Updated Successfully !');
          // this.emitImageSrc.emit({ data: this.imageSrc, value: 'profile' });
          // this.emitImageSrcData.emit({
          //   data: this.imageSrc,
          //   value: 'profile',
          // });
          // this.emitUpdatedDetails.emit({
          //   data: formInput,
          //   value: 'profile',
          // });
          this.subscriptionService.companylogoBS.next({"value":"userimage"});
          this.spinner = false;
          // if (this.fileData[0]) {
          //   this.accessPhotoSelect = false;
          // } else {
          //   this.accessPhotoSelect = true;
          // }
          this.accessPhotoSelect = false;
        },
        error: (error:HttpErrorResponse) => {
          this.notifier.notify('default', 'Something went error !');
          this.spinner = false;
        },
      });
    }
  }

  updateCompanyLogo() {
    const formInput = {
      company_logo_title: this.companyLogoForm.controls['title'].value,
      company_logo_caption: this.companyLogoForm.controls['caption'].value,
    };
    const convertJson = JSON.stringify(formInput);
    const formData = new FormData();
    if (this.companyLogoData.logo && !this.companyLogofileData[0]) {
      const file = this.DataURIToBlob(
        this.companyLogoImageSrc.changingThisBreaksApplicationSecurity
      );
      formData.append('file', file, 'image.jpg');
      this.companyLogoForm.get('logo')?.clearValidators();
      this.companyLogoForm.get('logo')?.updateValueAndValidity();
    } else if (
      this.companyLogoData.logo ||
      (!this.companyLogoData.logo && this.companyLogofileData[0])
    ) {
      formData.append(
        'file',
        this.companyLogofileData[0] ? this.companyLogofileData[0] : null
      );
      this.companyLogoForm.get('logo')?.clearValidators();
      this.companyLogoForm.get('logo')?.updateValueAndValidity();
    } else if (!this.companyLogofileData[0]) {
      formData.append(
        'file',
        this.companyLogofileData[0] ? this.companyLogofileData[0] : null
      );
    }
    formData.append('payload', convertJson);
    this.submitted = true;
    if (this.companyLogoForm.controls['logo'].valid) {
      if (this.companyLogoForm.valid) {
        this.spinner = true;
        this.subscriptionService.updateCompanyLogo(formData).subscribe({
          next: (response:any) => {
            this.spinner = false;
            this.submitted = false;
            this.accessCompanyPhotoSelect = true;
            // this.emitImageSrc.emit({
            //   data: this.companyLogoImageSrc,
            //   value: 'logo',
            // });
            // this.emitImageSrcData.emit({
            //   data: this.companyLogoImageSrc,
            //   value: 'logo',
            // });
            // this.emitUpdatedDetails.emit({
            //   data: formInput,
            //   value: 'logo',
            // });
            // if (this.companyLogofileData[0]) {
            //   this.accessCompanyPhotoSelect = false;
            // } else {
            //   this.accessCompanyPhotoSelect = true;
            // }
            this.subscriptionService.companylogoBS.next({"value":'logo'});
            this.accessCompanyPhotoSelect = false;
            this.notifier.notify('default', 'Company logo updated.');
          },
          error: (error:HttpErrorResponse) => {
            console.log('company logo api error');
            this.spinner = false;
          },
        });
      }
    } else {
      this.notifier.notify('default', 'Please select company logo image');
    }
  }

  getCompanyLogoData() {
    this.spinner = true;
    this.subscriptionService.getCompanyLogo().subscribe({
      next: (response:any) => {
        this.companyLogoData = response;
        this.companyLogoForm.controls['title'].setValue(
          this.companyLogoData.title
        );
        this.companyLogoForm.controls['caption'].setValue(
          this.companyLogoData.caption
        );
        const imageBase64 = this.companyLogoData.logo.replace(/b'|'/g, '');
        this.companyLogoImageSrc =
          this.sanitizer.bypassSecurityTrustResourceUrl(
            'data:image/jpg;base64,' + imageBase64
          );
        if (this.companyLogoData.logo) {
          this.showCompanyLogo = true;
        } else {
          this.showCompanyLogo = false;
        }
        if (!this.companyLogoData.logo) {
          this.accessCompanyPhotoSelect = true;
        } else {
          this.accessCompanyPhotoSelect = false;
        }
        this.spinner = false;
      },
      error: (error:HttpErrorResponse) => {
        console.log('company logo api error');
        this.spinner = false;
      },
    });
  }

  DataURIToBlob(dataURI: string) {
    const splitDataURI = dataURI.split(',');
    const byteString =
      splitDataURI[0].indexOf('base64') >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);
    return new Blob([ia], { type: mimeString });
  }

  userCountFun(value: any) {
    if (!value) {
      this.userCountEntry = 1;
    }
    if (value < this.userCount) {
      this.notifier.notify(
        'default',
        'User count should be more than previous count !'
      );
    }
  }

  currentPlan(value: string, plans: string, id: number) {
    this.currentPlanData = value;
    this.buyPlan = plans;
    this.subscriptionPlanId = id;
  }

  createToken(): void {
    const name = this.subscriptionForm.get('card_name')?.value;
    if (this.stripeCardValid === true && this.subscriptionForm.valid) {
      this.spinner2 = true;
      this.stripeService
        .createToken(this.card.element, { name })
        .subscribe((result) => {
          if (result.token) {
            // Use the token
            this.cardStripedToken = result.token.id;
            this.showSuccessSubscription = true;
            this.spinner2 = false;
            this.cardNumber = result.token.card?.last4!;
            this.zip = result.token.card?.address_zip!;
          } else if (result.error) {
            // Error creating the token
            this.spinner2 = false;
          }
        });
    } else {
      this.submitted = true;
      validationform.ValidateAllFormFields(this.subscriptionForm);
      this.notifier.notify('default', 'Please fill Mandatory field!');
    }
  }

  onChange(event: any) {
    if (event.complete === true) {
      this.stripeCardValid = event.complete;
    }
    if (event.complete === false) {
      this.stripeCardValid = event.complete;
    }
  }

  goBackSubscriptionFormSection() {
    this.showSuccessSubscription = false;
  }

  subscriptionSubmit() {
    if (this.subscriptionForm.valid && this.stripeCardValid) {
      this.spinner2 = true;
      const formValue = this.subscriptionForm.value;
      const formInput = {
        card_name: formValue.card_name.toUpperCase(),
        card_number: this.cardNumber,
        userscount: this.userCountEntry ? this.userCountEntry : 1,
        company_name: formValue.company_name,
        address1: formValue.address1,
        address2: formValue.address2,
        city: formValue.city,
        state: formValue.state,
        country: formValue.country,
        additioinal_users: 0,
        amount:
          this.buyPlan === 'Business'
            ? this.userCountEntry * 59 * 12 * 100
            : this.userCountEntry * 99 * 12 * 100,
        auto_renewal: null,
        description: this.buyPlan,
        planid: this.subscriptionPlanId,
        stripetoken: this.cardStripedToken,
        zip: this.zip,
      };
      this.subscriptionService.getSubscription(formInput).subscribe({
        next: (response:any) => {
          this.submitted = false;
          this.subscriptionForm.reset();
          this.showPlans = 'subcriptionDetails';
          this.getActivePlanDetails();
          this.spinner2 = false;
        },
        error: (error:HttpErrorResponse) => {
          console.log('subscription submission error', error.error['message']);
          this.spinner2 = false;
        },
      });
    } else {
      validationform.ValidateAllFormFields(this.subscriptionForm);
      this.notifier.notify('default', 'Please fill required field!');
    }
  }

  updatedAgentCount(value:number){
   const obj = {
    maximum_file_per_agent : value
    }
    this.subscriptionService.updateAgentFileUploadCount(obj).subscribe({
      next:(response:any) =>{
        this.notifier.notify('default', 'Updated Successfully.')
      },
      error:(error:HttpErrorResponse) =>{
        console.log("agent count api error", error.error['message']);
      }
    });
  }


   validateFileSelect(event:any,Filetypes:any):any{
    let getFileEvent = event;
  if (getFileEvent.target.files.length > 0) {
    
    for (let i = 0; this.getFileEvent.target.files.length > i; i++) {
      const file = this.getFileEvent.target.files[i];
      
      let fileExtension = file.name.substring(file.name.lastIndexOf('.')+1, file.name.length) || file.name;
      if (!Filetypes.includes(fileExtension)) {
        return false;
      }else{
        return true;
      }
    }
  }
 }

  phoneNumberInitialLoad() {
    setTimeout(()=>{
    this.initContry = intlTelInput(this.intlInput.nativeElement, {
       allowDropdown: true,
       nationalMode: true,
       initialCountry: 'in',
       separateDialCode: false
     });
    },1000);
 
   
     //controller.setCountry('JP');
     //controller.setNumber('9726502930');
   }
}
